// src/pages/AllDeadlines.js
import React from "react";
import { List, Card, Avatar, Typography, Button } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { formatDateOnly } from "Common/Components/FormatDateTime";
import { useLocation, useNavigate } from "react-router-dom";

const { Text } = Typography;

const AllDeadlines = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { darkMode = false, upcomingDeadlines } = location.state || {};
  return (
    <Card
      title={
        <span
          style={{
            color: darkMode ? "#fff" : "#9A6B0E",
          }}
        >
          All Deadlines
        </span>
      }
      style={{
        borderRadius: 12,
        backgroundColor: darkMode ? "#1f1f1f" : "#fff",
        borderColor: darkMode ? "#303030" : "#f0f0f0",
      }}
      extra={
        <Button type="default" onClick={() => navigate(-1)}>
          Back
        </Button>
      }
    >
      <List
        dataSource={upcomingDeadlines}
        renderItem={(item) => (
          <List.Item style={{ padding: "12px 0" }}>
            <List.Item.Meta
              avatar={
                <Avatar
                  style={{
                    backgroundColor:
                      item.priority === "high"
                        ? darkMode
                          ? "#ff4d4f33"
                          : "#fff2f0"
                        : item.priority === "medium"
                        ? darkMode
                          ? "#faad1433"
                          : "#fffbe6"
                        : darkMode
                        ? "#52c41a33"
                        : "#f6ffed",
                    color:
                      item.priority === "high"
                        ? "#ff4d4f"
                        : item.priority === "medium"
                        ? "#faad14"
                        : "#52c41a",
                  }}
                  icon={<FileTextOutlined />}
                />
              }
              title={
                <Text strong style={{ color: darkMode ? "#fff" : "#000" }}>
                  {item.title}
                </Text>
              }
              description={
                <Text type="secondary" style={{ color: darkMode ? "#999" : "#555" }}>
                  {item.trainingName} • {`Due: ${formatDateOnly(item.dueDate)}`}
                </Text>
              }
            />
          </List.Item>
        )}
      />
    </Card>
  );
};

export default AllDeadlines;
